export enum TipoVentaEnum {
    PRESENCIAL_CANTIDAD = 'PRESENCIAL_CANTIDAD',
    PRESENCIAL_CANTIDAD_CONEXION = 'PRESENCIAL_CANTIDAD_CONEXION',
    PRESENCIAL_CANTIDAD_OFERTA = 'PRESENCIAL_CANTIDAD_OFERTA',
    PRESENCIAL_SIMPLE = 'PRESENCIAL_SIMPLE',
    PRESENCIAL_CANTIDAD_TEMPORALIDAD = 'PRESENCIAL_CANTIDAD_TEMPORALIDAD',

    PRESENCIAL_CANTIDAD_FERIA = 'PRESENCIAL_CANTIDAD_FERIA',
    PRESENCIAL_DOBLE_CANTIDAD_CONEXION = 'PRESENCIAL_DOBLE_CANTIDAD_CONEXION',

    INTERNET_SIMPLE = 'INTERNET_SIMPLE',
    INTERNET_PROVEEDOR = 'INTERNET_PROVEEDOR',
    INTERNET_INTEGRADOR = 'INTERNET_INTEGRADOR',

    PRESENCIAL = 'PRESENCIAL',
    SERVICIO_WEB = 'SERVICIO_WEB'

}
